import {
  Box,
  Flex,
  Heading,
  Input,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { BILLING_FIELD_DEFS } from 'pages/Cockpit/AccountingInternal/constants/billingFields';
import {
  normalizeBillingDetails,
  validateBillingEmail,
} from 'pages/Cockpit/AccountingInternal/calc/billingDetails';
import BillingCountryField from 'pages/Cockpit/AccountingInternal/components/BillingCountryField';
import BillingStateField from 'pages/Cockpit/AccountingInternal/components/BillingStateField';
import EditCustomerSettings from './EditCustomerSettings';

const billingFields = BILLING_FIELD_DEFS.map((field) => ({
  ...field,
  element:
    field.name === 'country'
      ? BillingCountryField
      : field.name === 'state'
        ? BillingStateField
        : Input,
  getExtraProps:
    field.name === 'state'
      ? (values) => ({ country: values.country })
      : undefined,
  validate: field.name === 'billingEmail' ? validateBillingEmail : undefined,
  tooltip:
    field.name === 'billingEmail'
      ? 'Separate multiple emails with commas, e.g. billing@example.com, ap@example.com'
      : undefined,
  props:
    field.name === 'billingEmail'
      ? { placeholder: 'billing@example.com, ap@example.com' }
      : undefined,
}));

const CustomerBillingSettingsCard = ({ billingDetails, onSave }) => (
  <Card mt={6}>
    <Flex justifyContent="end" mb={4}>
      <EditCustomerSettings
        fields={billingFields}
        data={billingDetails || {}}
        onSave={(values) => onSave(normalizeBillingDetails(values, billingDetails))}
      />
    </Flex>
    <Heading variant="sectionHeader" borderColor="secondaryGray.600">
      Invoice billing
    </Heading>
    <SimpleGrid
      gridTemplateColumns="min-content min-content"
      whiteSpace="nowrap"
      spacingY={0}
      spacingX={10}
      fontSize="sm"
      mt={45}
    >
      {billingFields.map((field) => (
        <Fragment key={field.name}>
          <Text color="secondaryGray.600" fontWeight={500}>
            {field.label}
          </Text>
          <Text>{billingDetails?.[field.name] || '—'}</Text>
        </Fragment>
      ))}
      {!billingDetails && (
        <>
          <Box>&nbsp;</Box>
          <Text color="secondaryGray.500">No billing details saved yet.</Text>
        </>
      )}
    </SimpleGrid>
  </Card>
);

CustomerBillingSettingsCard.propTypes = {
  billingDetails: PropTypes.object,
  onSave: PropTypes.func.isRequired,
};

export default CustomerBillingSettingsCard;
